import { render, staticRenderFns } from "./dialog-change-tags.vue?vue&type=template&id=27481cad&scoped=true&"
import script from "./dialog-change-tags.vue?vue&type=script&lang=js&"
export * from "./dialog-change-tags.vue?vue&type=script&lang=js&"
import style0 from "./dialog-change-tags.vue?vue&type=style&index=0&id=27481cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27481cad",
  null
  
)

export default component.exports